angular.module('cvsApp').controller('validateUrlController', ['$rootScope', '$window', '$cookies', '$location', 'PAGE_PATH', 'validateDeepLinkService', 'msgManagerService', 'webTrendsService', 'cvsAppData', 'validateDeepLinkModel', 'RequestServiceHelper', 'commonService', '$base64', function ($rootScope, $window, $cookies, $location, PAGE_PATH, VDLS, MMS, WTS, CAD, VDLM, RequestServiceHelper, commonService, $base64) {
	'use strict';
	
	var VUC = this;
	var idelTime=0;
	var interval;
	var userActivity=false;
	CAD.setApiKey(cvsUtility.queryMap.apikey);
	cvsUtility.queryMap.tokenId = $cookies.get('SPLTY_TOKEN_ID', {path: '/'});

	if(cvsUtility.queryMap.tokenId){
		CAD.setAsTLPLogin(true);
	}
	if(!cvsUtility.queryMap.accessKey){
		
		if(cvsUtility.queryMap.tokenId){
			$rootScope.startSession();
			CAD.setOPTabData({isTabLocked: false});
			CAD.setRFRTabData({isTabLocked: false,isSelected: true});
			CAD.setQRTabData({isActive: false});
			CAD.setROTabData({isTabLocked: false});
            RequestServiceHelper.specialtyConfig().then(function(response){
                var config=response.configurationResponse.config;
                if(config && config.configKey && config.configKey=="PAYMENT-PUB-KEY"){
                    commonService.setPublicKey(config.configValue);
                }
            });
			$location.path('/refill-prescriptions');
return;
			if(cvsUtility.queryMap.qrComp){
				var qrComp = cvsUtility.queryMap.qrComp;
				if(qrComp.toUpperCase()==="RFR"){
					CAD.setOPTabData({isSelected: false});
					CAD.setRFRTabData({isSelected: true});
					CAD.setQRTabData({isSelected: false});
					$location.path('/RFR/RPR');

				}
				else if(qrComp.toUpperCase()==="OP"){
					CAD.setOPTabData({isSelected: true});
					CAD.setRFRTabData({isSelected: false});
					CAD.setQRTabData({isSelected: false});
					$location.path('/OP');

				}
			}


		}else if(cvsUtility.queryMap.xid && cvsUtility.queryMap.partialLoginToken){
			// console.log("XID LOGS",cvsUtility.queryMap.xid);
		}else {
			$location.path(PAGE_PATH.INVALID_REG);
		}
	}	

	if(cvsUtility.queryMap.partialLoginToken){
		/*{"apiResponse":{"memberOnlineStatus":"InActive","contextInformation":"QR",
		 "secureData":{"patientSourceSystem":"Specialty HBS","patientID":"7067278","campaignID":"1234",
		 "messageID":"367bbe20d38111e6affacd2032ac9bdd","campaignName":"secureChat"}},
		 "header":{"statusCode":"0000",
		 "statusDesc":"SUCCESS","refId":"Id-716b2d52ae8401002505000046a590fe","tokenID":"1AFF2EB0F89E3A27BFE265C166B71871"}}*/
		var response=
		{
			apiResponse:{
				"memberOnlineStatus":cvsUtility.queryMap.memberOnlineStatus?cvsUtility.queryMap.memberOnlineStatus:"InActive",
				"contextInformation":cvsUtility.queryMap.contextInformation?cvsUtility.queryMap.contextInformation:"xid",
				"trackingInformation":{
					"carrierName":cvsUtility.queryMap.carrierName,
					"carrierUrl":cvsUtility.queryMap.carrierUrl,
					"carrierNumber":cvsUtility.queryMap.carrierNumber
				},
				"memberInfoEnc":{
					"memberStatusEnc":cvsUtility.queryMap.memberStatusEnc,
					"sourceSystemNameEnc":cvsUtility.queryMap.sourceSystemNameEnc,
					"sourceSystemKeyValueEnc":cvsUtility.queryMap.sourceSystemKeyValueEnc
				}
			},
			"header":{
				"statusCode":"0000",
				"statusDesc":"SUCCESS",
				"tokenID":cvsUtility.queryMap.partialLoginToken
			}
		};
		VDLM.setHardCodedResponse(response);
		success(response);
	}else{
		VDLS.validateDeepLink(success);
		/*RequestServiceHelper.wcmService(CVS.Config.moduleWCM.guestRefill).then(function (response) {

			var keyArr=CVS.Config.moduleWCM.guestRefill.split(",");
			if(response){
				for(var key=0;key<keyArr.length;key++){
					if(response[keyArr[key]] && response[keyArr[key]].header && response[keyArr[key]].header.responseCode &&
						response[keyArr[key]].header.responseCode=="DBPL0000"){
						var object = angular.merge({},  refillWcmContent[CVS.Config.wcmMapping[keyArr[key]]], response[keyArr[key]].details[CVS.Config.wcmMapping[keyArr[key]]]);
						refillWcmContent[CVS.Config.wcmMapping[keyArr[key]]]=object;
						refillWcmContent[CVS.Config.wcmMapping[keyArr[key]]].isSyncSuccess = true;
					}
				}
			}
		VDLS.validateDeepLink(success);
		},function(error){
			VDLS.validateDeepLink(success);
		});*/


	}

	//debugger;
	function success (data) {


		var patientId = null;
		var accessSource = cvsUtility.queryMap.source;
        /**
         * SP 03/22/2017
         * Added logic to check guest refill switch based on desktop/ mobile web/ mobiel app
         * @type {string}
         */
        var componentName = 'GR';
        var isGRDisabled = false;
        if(refillWcmContent && refillWcmContent.fast_config && refillWcmContent.fast_config.component_config){
            var configValues = refillWcmContent.fast_config.component_config.hasOwnProperty('config')? refillWcmContent.fast_config.component_config.config : refillWcmContent.fast_config.component_config;
            for(var configIndex = 0; configIndex < configValues.length; configIndex++){
                if(configValues[configIndex].componentname == componentName){
                    var deviceType="desktop";
                    if(cvsUtility.queryMap.mobileAppStyle!=undefined && (cvsUtility.queryMap.mobileAppStyle==true || cvsUtility.queryMap.mobileAppStyle=="true")){
                        /****checking for mobile App****/
                        deviceType="mobileApp";
                    }
                    else if( cvsUtility.isMobile()) {
                        /****checking for mobile web****/
                        deviceType="mobile";
                    }

                    switch(deviceType) {
                        case "mobile":
                            if(configValues[configIndex].channelswitches.mobileweb==="N"){
                                isGRDisabled = true;
                            }
                            break;
                        case "mobileApp":
                            if(configValues[configIndex].channelswitches.mobileapp==="N"){
                                isGRDisabled = true;
                            }
                            break;
                        default:
                            if(configValues[configIndex].channelswitches.desktop==="N"){
                                isGRDisabled = true;
                            }
                            break;
                    }

                    CAD.setGRDisabled( isGRDisabled);
                    break;
                }
            }
        }

        if(data.SERVER_ERROR){
            VUC.ERROR = data.ERROR_MSG;
            VUC.showErr= true;
            
            return;
        }
    	//TODO uncomment
		if(data.getError){
			VUC.showError = data.getError();
		}
    	if(data.showView){
			VUC.showView = data.showView();
		}
        /**
		 * Format response to 2.1 compatible
         */
		var apiResponse = data.apiResponse;
        if(apiResponse.hasOwnProperty('memberInfo') && apiResponse.memberInfo.hasOwnProperty('memberStatus')){
        	apiResponse.memberOnlineStatus = apiResponse.memberInfo.memberStatus;
		}
		if(apiResponse.hasOwnProperty('specialtyPatientMessage')){
        	apiResponse.contextInformation = apiResponse.specialtyPatientMessage.contextInformation;
        	apiResponse.trackingInformation = apiResponse.specialtyPatientMessage.trackingInformation;
			apiResponse.screenSource = apiResponse.specialtyPatientMessage.screenSource;
		}
		if (apiResponse.hasOwnProperty('specialtyPatientMessage') && apiResponse.specialtyPatientMessage.hasOwnProperty('trackingInformation')){
			if (apiResponse.specialtyPatientMessage.trackingInformation.hasOwnProperty('shipmentNumber')){
				var shipNum = apiResponse.specialtyPatientMessage.trackingInformation.shipmentNumber;
				sessionStorage.setItem("TAPInfo", $base64.encode(shipNum));
			}
		}
		data.apiResponse = apiResponse;

		VUC.data = data;
		if(cvsUtility.queryMap.partialLoginToken){
			VUC.showError="";//TODO comment
		}

		CAD.contextInfo = data.apiResponse;
		var shipmentNumber = null;
		if(data.apiResponse && data.apiResponse.trackingInformation) {
			shipmentNumber = data.apiResponse.trackingInformation.shipmentNumber;
		}

		if(VUC.showError === ""){

			patientId = data.apiResponse && data.apiResponse.hasOwnProperty("memberInfoEnc") && data.apiResponse.memberInfoEnc.hasOwnProperty("sourceSystemKeyValueEnc") ? data.apiResponse.memberInfoEnc.sourceSystemKeyValueEnc: null;
			cvsUtility.setPatientId(patientId);
			cvsUtility.setMemberstatus(data.apiResponse.memberOnlineStatus.toUpperCase()==PAGE_PATH.INACTIVE ? 'Unregistered' : 'Registered')

			var utagObj = {};
			/*WTS.webTrendsUtag("OBJ",{ page_name:'QR: Confirm ID',
				scenario_step:"QR: Registration: Quick Reg Landing Page",
				scenario_name:"QR: Registration",
				page_category:'Quick Registration',
				tsrc: cvsUtility.queryMap.source,
				Page_Event:0
				//patient_id: patientId
			});*/
			if(cvsUtility.queryMap.tokenId){
				$rootScope.startSession();

                RequestServiceHelper.specialtyConfig().then(function(response){
                    var config=response.configurationResponse.config;
                    if(config && config.configKey && config.configKey=="PAYMENT-PUB-KEY"){
                        commonService.setPublicKey(config.configValue);
                    }
                });
				var contextInformation;
				if(_.isObject(data.apiResponse.contextInformation)){
					contextInformation=data.apiResponse.contextInformation.__text;
				}else{
					contextInformation=data.apiResponse.contextInformation;
				}
				/**
				 * Sudhir 02/10/2017 - Feb 2017 Regression defect fix
				 * Added logic to handle new line characters introduced by xmls2json library in IE11
				 * */
				contextInformation = contextInformation.replace(/\n/g,'');
				switch (contextInformation.toUpperCase()) {
					case PAGE_PATH.TAP: 
						CAD.setOPTabData({isTabLocked: false});
						CAD.setRFRTabData({isTabLocked: false, isActive: true,isSelected: true});
						CAD.setQRTabData({isActive: false});
						CAD.setROTabData({isTabLocked: false});
						CAD.setTAPTabData({isActive: true,isSelected: true, shipmentNumber: shipmentNumber});
						$location.path('/track-order/'+shipmentNumber);
						break;
					case PAGE_PATH.OP:
					case PAGE_PATH.OLPBD:
					case PAGE_PATH.OLPPS:
					case PAGE_PATH.OLP:
					case PAGE_PATH.PS:
					case PAGE_PATH.BD:
						CAD.setOPTabData({isTabLocked: false,isSelected: true});
						CAD.setRFRTabData({isTabLocked: false});
						CAD.setROTabData({isTabLocked: false});
						CAD.setQRTabData({isActive: false});
						$location.path(PAGE_PATH.PATH.REFILL_OP);
						break;
					default:
						CAD.setOPTabData({isTabLocked: false});
						CAD.setROTabData({isTabLocked: false});
						CAD.setRFRTabData({isTabLocked: false,isSelected: true});
						CAD.setQRTabData({isActive: false});
						$location.path('/refill-prescriptions');
				}
				return false;
			}else {
				if(!cvsUtility.queryMap.accessKey && (!cvsUtility.queryMap.xid)){
					$location.path(PAGE_PATH.INVALID_REG);
					return false;
				}
			}
			cvsUtility.resetSessoinTimeOut();
			var contextInformation;
			if(_.isObject(data.apiResponse.contextInformation)){
				contextInformation=data.apiResponse.contextInformation.__text;
			}else{
				contextInformation=data.apiResponse.contextInformation;
			}
	        if (data.apiResponse.memberOnlineStatus.toUpperCase()==PAGE_PATH.INACTIVE) {
	        	if(contextInformation.toUpperCase() == PAGE_PATH.TAP){
					CAD.setTAPTabData({isActive: true, shipmentNumber: shipmentNumber});
				}
       	 		$location.path(PAGE_PATH.CONF_ID);
	        }
	        else if(data.apiResponse.memberOnlineStatus.toUpperCase()==PAGE_PATH.ACTIVE){
				  if(_.isObject(data.apiResponse.contextInformation)){
                      //cvsUtility.sendPostMessage("activeUser");
                      /**
                       * Sudhir 02/10/2017 - Feb 2017 Regression defect fix
                       * Added logic to handle new line characters introduced by xmls2json library in IE11
                       * */
                      contextInformation = contextInformation.replace(/\n/g,'');
                      $window.top.location = cvsUtility.getRedirecttoLogin(contextInformation.toUpperCase());

					  // switch (data.apiResponse.contextInformation.__text.toUpperCase()) {
						//   case PAGE_PATH.TAP:
						// 	  CAD.setOPTabData({isTabLocked: true});
						// 	  CAD.setRFRTabData({isTabLocked: true});
						// 	  CAD.setQRTabData({isActive: false});
						// 	  CAD.setTAPTabData({isActive: true,isSelected: true, shipmentNumber: shipmentNumber});
						// 	  $location.path(PAGE_PATH.TRACK_PACK);
						// 	  break;
                      //
						//   default:
						//
					  // }
				  } else {
                      //cvsUtility.sendPostMessage("activeUser");
                      /**
                       * Sudhir 02/10/2017 - Feb 2017 Regression defect fix
                       * Added logic to handle new line characters introduced by xmls2json library in IE11
                       * */
                      $window.top.location = cvsUtility.getRedirecttoLogin(data.apiResponse.contextInformation.replace(/\n/g,'').toUpperCase());

					  /*switch (data.apiResponse.contextInformation.toUpperCase()) {
						  case PAGE_PATH.TAP:
							  CAD.setOPTabData({isTabLocked: true});
							  CAD.setRFRTabData({isTabLocked: true});
							  CAD.setQRTabData({isActive: false});
							  CAD.setTAPTabData({isActive: true,isSelected: true, shipmentNumber: shipmentNumber});
							  $location.path(PAGE_PATH.TRACK_PACK);
							  break;

						  default:

					  }*/
				  }


	        	 /*if(data.apiResponse.contextInformation.toUpperCase()==PAGE_PATH.TAP){
        	 		CAD.setOPTabData({isTabLocked: false});
					CAD.setRFRTabData({isTabLocked: false});
					CAD.setQRTabData({isActive: false});
					CAD.setTAPTabData({isActive: true,isSelected: true});
	        		 $location.path(PAGE_PATH.TRACK_PACK);
	        	 }
	        	 else if((data.apiResponse.contextInformation.toUpperCase()==PAGE_PATH.RFR)){
	        	 	CAD.setOPTabData({isTabLocked: false});
					CAD.setRFRTabData({isTabLocked: false,isSelected: true});
					CAD.setQRTabData({isActive: false});
	        	 	$location.path(PAGE_PATH.READY_FOR_REFILL+PAGE_PATH.PATH.REFILL_PRESC);
	        	 }
	        	 else{
	        		 cvsUtility.sendPostMessage("activeUser");
	        		 var qrlogin = createChannelUrl('qrlogin'),
	        		 	 key =  "&accessKey="+cvsUtility.queryMap.accessKey,
	        		 	 redirectUrl = qrlogin;
	        		 	 if(cvsUtility.queryMap.accessKey){
	        		 	 	redirectUrl = qrlogin+key;
	        		 	 }
	        	 	$window.top.location = redirectUrl;
	        	 }*/
	        		

	        }else{
	        	WTS.webTrendsUtag("OBJ",{ page_name:'QR: Confirm ID - Error',
					                           scenario_step:"QR: Registration: Quick Reg Landing Page",
					                           scenario_name:"QR: Registration",
					                           page_category:'Quick Registration',
					                           page_error:"QR:Confirm ID - Error",
					                           tsrc: cvsUtility.queryMap.source,
					                           Page_Event:0
					             });
	        	
	        	$location.path(PAGE_PATH.INVALID_REG);
	        }
	    }
	    else{
	    	/*WTS.webTrendsUtag("OBJ",{ page_name:'QR: Landing - Back-end/Technical Error',
			                           page_category:'Quick Registration',
			                           page_error:"QR:Confirm ID - Back-end/Technical Error",
				                       tsrc: cvsUtility.queryMap.source,
			                           Page_Event:0
			            });*/
			/**
			 * sankar 02/10/2016 - SMP 009 - validateDeepLink service error
			 * Modified page_error tag
			 */
			var pageError = cvsUtility.getPageError(data, 'Fatal', 'validateDeepLink');

			/*WTS.webTrendsUtag("LINK",{ page_name:'QR: Landing - Back-end/Technical Error',
				page_category:'Quick Registration',
				page_error:pageError,
				tsrc: cvsUtility.queryMap.source,
				Page_Event:0,
				campaign: accessSource
			});*/
	    	$location.path(PAGE_PATH.INVALID_REG);
	    }
        
    }
    
}]);
